// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"5ac033ca","453":"78a7e200","951":"dcbfca82"}[chunkId] + ".chunk.js";
};